module.exports = "https://bin.bnbstatic.com/_next/static/images/launchpad-61195f226dbfd2b733d0697586b1ac3d.png";